import { AxiosResponse } from 'axios'
import { OliveUser } from 'src/types/oliveUser'

import axios from '../../axios'

export const fetchOliveUser = async (id: string): Promise<AxiosResponse> => {
  const response = await axios
    .get<{ data: OliveUser }>(`/api/olive-users/${id}`)
    .catch((error) => {
      return error.response
    })

  return response
}
